import React from 'react';
import AboutProperties from '../../../../stories/components/hotels/DetailsPage/AboutProperties/AboutProperties';
import {aboutCitySelector} from '../redux/selectors';
import {useSelector} from 'react-redux';

const AboutCity = () => {
  const aboutCityData = useSelector(aboutCitySelector);
  const {desc = '', title = 'About city'} = aboutCityData;
  return <>{!!desc && desc.length > 0 && <AboutProperties text={title} data={desc} />}</>;
};

export default AboutCity;
